import { PlayerEnvironment } from './player_environment';

export default class HdcpBlocker {
  constructor({ tech, data } = {}) {
    this._tech = tech;
    this._data = data;
    this._blockerCountdown = 5 * 1000;
    this._started = false;
    this._blockerInterval = null;
  }

  tech() {
    return this._tech;
  }

  data() {
    return this._data;
  }

  blockerCountdown() {
    return this._blockerCountdown;
  }

  started() {
    return this._started;
  }

  init() {
    this.checkPlayability();
    this.onContentStart();
  }

  checkPlayability() {
    if (PlayerEnvironment.isMobileSite()) {
      this._blockerCountdown = 0;
      this.onContentBuffer();
    } else {
      this.onContentBuffer();
    }
  }

  onContentBuffer() {
    this.tech().one('bufferstart', () => {
      this.contentBufferHandler();
    });
  }

  contentBufferHandler() {
    if (this.started()) return;

    this._blockerInterval = setInterval(() => {
      this.removeInterval();
      this.showBlocker();
    }, this.blockerCountdown());
  }

  onContentStart() {
    this.tech().on('vp-start', () => {
      this._started = true;
      this.removeInterval();
    });
  }

  removeInterval() {
    clearInterval(this._blockerInterval);
    this._blockerInterval = null;
  }

  showBlocker() {
    this.tech().error(7);
  }
}
